import styled from 'styled-components';

export const BtnWrapper = styled.div`
    background: transparent;
    padding: 1rem 0;
`;


// WEBPACK FOOTER //
// ./src/components/AttributeRow/Styled.js